import script from "./ThemesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesView.vue?vue&type=script&setup=true&lang=js"

import "./ThemesView.vue?vue&type=style&index=0&id=b15cabfc&lang=scss"

const __exports__ = script;

export default __exports__